'use client';
import type { ReactNode } from 'react';
import { useContext } from 'react';
import { clsx } from 'clsx';
import styles from 'components/UI/AdSlot/AdSlot.module.scss';
import { isMobileAd } from 'components/UI/AdSlot/AdSlotHelper';
import { AppContext } from 'context/AppContext';
import { AdSlotType, type AdSizePredictionProps } from 'types/ads';

interface PredictionMinHeightProps {
  adSizePrediction: AdSizePredictionProps | undefined;
  adSlotName: string;
  adZone: string;
  isMobile: boolean;
}

interface AdSlotPredictionProps {
  adSlotName: string;
  children: ReactNode;
}

export const predictionMinHeight = ({ adSizePrediction, adSlotName, adZone, isMobile }: PredictionMinHeightProps) => {
  if (!adSizePrediction) {
    return '';
  }

  const predictionEnv = adSizePrediction[isMobile ? AdSlotType.Mobile : AdSlotType.Desktop];
  const predictionZone = predictionEnv[adZone];
  return predictionZone?.[adSlotName] ? `${predictionZone[adSlotName].percentile90}px` : 'auto';
};

export const AdSizePrediction = ({ adSlotName, children }: AdSlotPredictionProps) => {
  const {
    pageMetaData: { adZone, noAds },
    adSizePrediction,
  } = useContext(AppContext);

  const isMobile = isMobileAd(adSlotName);
  const minHeight = predictionMinHeight({
    adSizePrediction,
    adSlotName,
    adZone,
    isMobile,
  });

  if (noAds) {
    return null;
  }

  return (
    <div
      className={clsx('adSlotName', { [styles.mobile]: isMobile, [styles.desktop]: !isMobile })}
      style={{ minHeight: `${minHeight}` }}
    >
      {children}
    </div>
  );
};
